import { Node, mergeAttributes } from '@tiptap/core';

export default Node.create({
  name: 'video',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      src: {
        default: null,
        parseHTML: (element) => element.getAttribute('src'),
        renderHTML: (attributes) => {
          return {
            src: attributes.src || null,
          };
        }
      },
      controls: {
        default: true,
        parseHTML: (element) => element.hasAttribute('controls'),
        renderHTML: (attributes) => {
          return {
            controls: attributes.controls ? '' : null,
          };
        }
      },
      muted: {
        default: false,
        parseHTML: (element) => element.hasAttribute('muted'),
        renderHTML: (attributes) => {
          return {
            muted: attributes.muted ? '' : null,
          };
        }
      },
      autoplay: {
        default: false,
        parseHTML: (element) => element.hasAttribute('autoplay'),
        renderHTML: (attributes) => {
          return {
            autoplay: attributes.autoplay ? '' : null,
          };
        }
      },
      loop: {
        default: false,
        parseHTML: (element) => element.hasAttribute('loop'),
        renderHTML: (attributes) => {
          return {
            loop: attributes.loop ? '' : null,
          };
        }
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'video',
        getAttrs: (element) => {
          return {
            src: element.getAttribute('src'),
            controls: element.hasAttribute('controls'),
            muted: element.hasAttribute('muted'),
            autoplay: element.hasAttribute('autoplay'),
          };
        }
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['video', mergeAttributes(HTMLAttributes)];
  }
});
